import script from "./record-card.vue?vue&type=script&setup=true&lang=js"
export * from "./record-card.vue?vue&type=script&setup=true&lang=js"

import "./record-card.vue?vue&type=style&index=0&id=5156397e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5156397e"]])

export default __exports__